import './cellRenderers.css';
import PropTypes from 'prop-types';
import UploadElement from '../../UploadElement';
import withCurrentData from './withCurrentData';
import { isEmptyValue, getEmptyPlaceholder } from './cellRendererUtils';

function UploadCellRenderer(props) {
  const { value, componentProps, emptyPlaceholder } = props;

  if (emptyPlaceholder && isEmptyValue(value)) {
    return getEmptyPlaceholder(emptyPlaceholder);
  }

  return (
    <UploadElement
      className="table-upload-cell"
      value={value}
      readonly={true}
      componentProps={componentProps}
    />
  );
}

UploadCellRenderer.propTypes = {
  value: PropTypes.shape({
    resources: PropTypes.arrayOf(
      PropTypes.shape({
        storageId: PropTypes.string,
        fileName: PropTypes.string,
        url: PropTypes.string,
      }),
    ),
  }),
  data: PropTypes.shape({}),
  /**
   * 当值为空时显示的占位符。传 true 默认显示 '-'，传字符串则显示自定义内容
   */
  emptyPlaceholder: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  componentProps: PropTypes.shape({}),
};

export default withCurrentData(UploadCellRenderer);
